import { render, staticRenderFns } from "./BiochemicalReagent.vue?vue&type=template&id=0b13fe0f&scoped=true"
import script from "./BiochemicalReagent.vue?vue&type=script&lang=js"
export * from "./BiochemicalReagent.vue?vue&type=script&lang=js"
import style0 from "./BiochemicalReagent.vue?vue&type=style&index=0&id=0b13fe0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13fe0f",
  null
  
)

export default component.exports